import React from 'react'
import { TwoFactorAuthenticationPanel } from '@sketch/user'
import SessionsManagementPanel from './SessionsManagementPanel'

import {
  getPersonalAuthorization,
  useUserProfile,
  useIsSocialSignInOnly,
} from '@sketch/modules-common'

const SecuritySettings: React.FC = () => {
  const { data: userData } = useUserProfile()
  const isSocialSignInOnly = useIsSocialSignInOnly()

  const user = userData?.me

  if (!user) {
    return null
  }

  const isSsoOnly = !getPersonalAuthorization()

  return (
    <>
      {!isSsoOnly && !isSocialSignInOnly && (
        <TwoFactorAuthenticationPanel
          mfaState={user.mfaState}
          isVerified={user.isVerified}
        />
      )}

      {/* Sessions Management Panel */}
      <SessionsManagementPanel />
    </>
  )
}

export default SecuritySettings
